import React from "react";
import { Grid } from "@mui/material";

const GridContainerItem = ({
  children,
}: {
  children: React.ReactNode;
}): React.JSX.Element => {
  return (
    <Grid
      className="scd-container-base"
      container
      spacing={2}
      size={{ xs: 12 }}
    >
      {children}
    </Grid>
  );
};

export default GridContainerItem;
